import React, { useEffect, useRef, useState } from 'react'
import api from '../../../api';
import { Dropdown } from 'primereact/dropdown';
import { useFormik } from "formik";
import * as Yup from "yup";
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
  Legend, BarChart, Bar,
  PieChart,
  Pie,
  Cell
} from 'recharts';
import { ProgressSpinner } from 'primereact/progressspinner';


const PRSData = () => {

        const currentDate1 = new Date();
        const formattedCurrentDate = `${currentDate1.getDate().toString().padStart(2, '0')}-${(currentDate1.getMonth() + 1).toString().padStart(2, '0')}-${currentDate1.getFullYear()} ${currentDate1.getHours().toString().padStart(2, '0')}:${currentDate1.getMinutes().toString().padStart(2, '0')}:${currentDate1.getSeconds().toString().padStart(2, '0')}`;
        const userID = sessionStorage.getItem("UserID");
        const roleID = sessionStorage.getItem("RoleID");
    
        const [loading, setLoading] = useState(false);
        const toast = useRef(null);
    
        const typeName = [
          { id: "1", label: "Control" },
          { id: "2", label: "Intervention" },
        ];
    
        const [selectedSite, setSelectedSite] = useState({ site_code: "" });
        const [selectedType, setSelectedType] = useState("");
        const [date, setDate] = useState(null);
        const [date1, setDate1] = useState(null);
        
    
        const [site, setSite] = useState([]);
        const getSite = async () => {
          try {
        setLoading(true);

            const requestData = {
              logged_in_userid : userID,
              role_id : roleID,
              state_id: "",
              synceddatetime : formattedCurrentDate,
              FormCode : "202",
              ApiKey : "kavin",
              AppTypeNo : "3",
              AppVersion : "1.0.0",
              data_source : "W"
            };
              const result = await api.get_Filter_Site(requestData);
              const sitesData = result.site_admin_details.map((site) => ({
              label: site.fld_site_name,
              value: site.fld_site_name,
              site_code: site.fld_site_id,
              site_swid: site.fld_site_sw_id
            }));
    
            setSite(sitesData);
          } catch (error) {
            console.error("Error fetching site:", error);
          }  finally {
        setLoading(false);
    }
        };
    
        useEffect(() => {
          getSite();
        }, []);


        const [noParticpantsEnrolledData, setNoParticpantsEnrolledData] = useState(0);
        const [noHealthWorkerEnrolledData, setNoHealthWorkerEnrolledData] = useState(0);
        const [noParticipantScreenedData, setNoParticipantScreenedData] = useState(0);
        const [noparticipantsscreenedHCWData, setNoparticipantsscreenedHCWData] = useState([]);
        const [noparticipantsPositiveHealthWorkerData, setNoparticipantsPositiveHealthWorkerData] = useState([]);
        const [noParticipantsmildDepressionHCWData, setNoParticipantsmildDepressionHCWData] = useState([]);
        const [noParticipantNeedingReferralData, setNoParticipantNeedingReferralData] = useState(0);
        const [pendingBaselineCounsellingF0Data, setPendingBaselineCounsellingF0Data] = useState(0);
        const [pendingFollowupsData, setpendingFollowupsData] = useState(0);
        const [completedFollowUpsF0F1F2F3F4Data, setCompletedFollowUpsF0F1F2F3F4Data] = useState(0);
        const [noofParticpantsDropoutData, setNoofParticpantsDropoutData] = useState([]);
        const [noHWsDropoutsWithdrawalData, setNoHWsDropoutsWithdrawalData] = useState(0);
        const [noParticipantReferralRequestData, setNoParticipantReferralRequestData] = useState(0);


        const getOverall = async () => {
        try {
        setLoading(true);

        const requestData = {
            role_code : roleID,
	        login_user_id : userID,
            state_id : "",
            from_month_id : "",
            to_month_id : "",
            from_year_id : "",
            to_year_id : "",
	        prs_id :"",
	        prs_name :"",
	        phc_type_id : "",
	        phc_type_name :"",
	        phc_id :"",
	        phc_name :"",
	        site_id :"",
	        site_name :"",
            request_table : {
                PrsSiteAdminDashboard : "",
            },
            synceddatetime : "02-07-2025 11:14:18",
            FormCode : "218",
            ApiKey : "kavin",
            AppTypeNo : "3",
            AppVersion : "1.0.0",
            Data_source : "W"
        };
        const result = await api.get_PRS_Dashboard(requestData);

        const noParticpantsEnrolled = result?.responsemessage?.PrsSiteAdminDashboard?.[0]?.NoOfParticipantsEnrolled?.[0]?.total_no_of_participants_giving_consent ?? null;
        const noHealthWorkerEnrolled = result?.responsemessage?.PrsSiteAdminDashboard?.[0]?.NoOfHealthWorkerEnrolled?.[0]?.registration_of_hws ?? null;
        const noParticipantScreened = result?.responsemessage?.PrsSiteAdminDashboard?.[0]?.NoOfParticipantScreened?.[0]?.no_of_participants_screened ?? null;
        const noparticipantsscreenedHCW = result?.responsemessage?.PrsSiteAdminDashboard?.[0]?.NoOfParticipantsScreenedPerHCW || [];
        const formattedScreenedData = noparticipantsscreenedHCW.map(item => ({
          hcwId: item.hcw_id,
          participants: Number(item.no_of_Participants_screened_per_hcw),
        }));

        const noparticipantsPositiveHealthWorker = result?.responsemessage?.PrsSiteAdminDashboard?.[0]?.NoOfParticipantsScreenedPositiveByHealthWorker || [];
        const formattedScreenedPositiveData = noparticipantsPositiveHealthWorker.map(item => ({
          phcName: item.fld_phc_name,
          positiveCount: Number(item.no_of_participants_screened_positive_by_health_worker)
        }));

        const noParticipantsmildDepressionHCW = result?.responsemessage?.PrsSiteAdminDashboard?.[0]?.NoOfParticipantsIdentifiedWithMildDepressionByHCW || [];    
        const formattedMildDepression = noParticipantsmildDepressionHCW.map(item => ({
          name: item.fld_phc_name,
          value: Number(item.no_of_participants_identified_with_mild_depression_by_hcw)
        }));

        const noParticipantNeedingReferral = result?.responsemessage?.PrsSiteAdminDashboard?.[0]?.NoOfParticipantNeedingReferral?.[0]?.no_of_participant_needing_referral ?? null;
        const pendingBaselineCounsellingF0 = result?.responsemessage?.PrsSiteAdminDashboard?.[0]?.PendingBaselineCounsellingF0?.[0]?.pending_baseline_counseling_f0 ?? null;
        const pendingFollowups = result?.responsemessage?.PrsSiteAdminDashboard?.[0]?.PendingFollowups?.[0]?.pending_followups ?? null;
        const completedFollowUpsF0F1F2F3F4 = result?.responsemessage?.PrsSiteAdminDashboard?.[0]?.CompletedFollowupsF0F1F2F3F4?.[0]?.completed_follow_ups_f0_f1_f2_f3_f4 ?? null;

        const dropoutDataRaw = result?.responsemessage?.PrsSiteAdminDashboard?.[0]?.NoOfParticipantsDropoutsOrWithdrawal || [];
        const noofParticpantsDropout = dropoutDataRaw.map(item => ({
          phcName: item.fld_phc_name,
          total_withdrawals: Number(item.total_withdrawals),
          dropout_phq2: Number(item.dropout_phq2),
          dropout_phq9: Number(item.dropout_phq9),
          lost_f0: Number(item.lost_f0),
          lost_f1: Number(item.lost_f1),
          lost_f2: Number(item.lost_f2),
          lost_f3: Number(item.lost_f3),
          lost_f4: Number(item.lost_f4),
        }));

        const noHWsDropoutsWithdrawal = result?.responsemessage?.PrsSiteAdminDashboard?.[0]?.NoOfHWsDropoutsOrWithdrawal?.[0]?.no_of_hws_dropouts_or_withdrawal ?? null;
        const noParticipantReferralRequest = result?.responsemessage?.PrsSiteAdminDashboard?.[0]?.NoOfParticipantsComplianceToReferralRequest?.[0]?.no_of_participants_compliance_to_referral_request ?? null;


        setNoParticpantsEnrolledData(noParticpantsEnrolled);
        setNoHealthWorkerEnrolledData(noHealthWorkerEnrolled);
        setNoParticipantScreenedData(noParticipantScreened);
        setNoparticipantsscreenedHCWData(formattedScreenedData);
        setNoparticipantsPositiveHealthWorkerData(formattedScreenedPositiveData);
        setNoParticipantsmildDepressionHCWData(formattedMildDepression);
        setNoParticipantNeedingReferralData(noParticipantNeedingReferral);
        setPendingBaselineCounsellingF0Data(pendingBaselineCounsellingF0);
        setpendingFollowupsData(pendingFollowups);
        setCompletedFollowUpsF0F1F2F3F4Data(completedFollowUpsF0F1F2F3F4);
        setNoofParticpantsDropoutData(noofParticpantsDropout);
        setNoHWsDropoutsWithdrawalData(noHWsDropoutsWithdrawal);
        setNoParticipantReferralRequestData(noParticipantReferralRequest);


      } catch (error) {
        console.error("Error fetching site:", error);
      } finally {
        setLoading(false);
    }
    };

    useEffect(() => {
      getOverall();
    }, []);



    
    const formik = useFormik({
    initialValues: {
      site_name:"",
      taluk_name:"",
      prs_name:"",
      village_name:"",
      phc_name:"",
      phc_type_name:""
    },
    validationSchema: Yup.object({
      site_name: Yup.string().required("Site Code is required"),
      taluk_name: Yup.string().required("Taluk Name is required"),
      prs_name: Yup.string().required("PRS Name is required"),
      village_name: Yup.string().required("Village Name is required"),
      phc_name: Yup.string().required("PHC Name is required"),
      phc_type_name: Yup.string().required("PHC Type is required"),


    }),

    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);
        const additionalData = {
          // state_id: selectedState?.state_code || "",
          state_id: values.state_code,
          district_id: values.district_code,
          site_id: values.site_code,
          taluk_id: values.taluk_code,
          fld_mapped_prs_id: values.prs_userID,
          village_id: values.village_code,
          phc_name: values.phc_name,
          phc_type_name: values.phc_type_name,
          phc_type_id: values.phc_type_id,
          synceddatetime: formattedCurrentDate,
          FormCode: "202",
          ApiKey: "kavin",
          AppTypeNo: "3",
          AppVersion: "1.0.0",
          data_source: "W",
          loggedin_user_id: userID,
        };

        const response = await api.add_PHC(additionalData);

        if (response && response.status === "1") {
          toast.current.show({
            severity: "success",
            summary: "PHC Created Successful",
            detail:
              response.responsemessage ||
              "You have successfully created the PHC.",
          });
          resetForm();
        } else {
          throw new Error(
            response
              ? response.responsemessage ||
                "An error occurred while creating the PHC."
              : "No response from the server."
          );
        }
      } catch (error) {
        console.error("PHC submission error:", error);

        toast.current.show({
          severity: "error",
          summary: " PHC Failed",
          detail:
            error.message || "An unexpected error occurred. Please try again.",
        });
      } finally {
        setLoading(false);
    }
    },
    });


    const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042']; // add more if needed

    const renderCustomizedLabel = ({
      cx, cy, midAngle, innerRadius, outerRadius, percent, index, value
    }) => {
      const RADIAN = Math.PI / 180;
      const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
      const x = cx + radius * Math.cos(-midAngle * RADIAN);
      const y = cy + radius * Math.sin(-midAngle * RADIAN);

      return (
        <text
          x={x}
          y={y}
          fill="white"
          textAnchor="middle"
          dominantBaseline="central"
          fontSize={14}
          fontWeight="bold"
        >
          {value}
        </text>
      );
    };

  return (
    <div>
                {loading && (
                    <div className="backdrop">
                        <ProgressSpinner style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />
                    </div>
                )}
                {/* <div className='flex justify-content-between align-items-center'>
                    <Dropdown
                       id="site_name"
                       name="site_name"
                       placeholder="Select Site"
                       value={formik.values.site_name}
                       className= "dashboard-dropdown-filter"
                       options={site}
                       disabled={roleID === "2"}
                       onChange={(e) => {
                         const selectedSite = site.find(
                           (siteObj) => siteObj.value === e.value
                         );
                         setSelectedSite(selectedSite);
                         formik.setFieldValue("site_name", e.value);
                         if (selectedSite) {
                           formik.setFieldValue("site_code", selectedSite.site_code || "");
                           formik.setFieldValue("site_sw_id", selectedSite.site_swid || "");
                         } else {
                           formik.setFieldValue("site_code", "");
                           formik.setFieldValue("site_sw_id", "");
                           setSite([]);
                         }
                       }}
                    />
        
                    <Dropdown
                      id="phc_type_name"
                      name="phc_type_name"
                      placeholder="Select PHC Type"
                      className= "dashboard-dropdown-filter"
                      options={typeName}
                      value={selectedType}
                      onChange={(e) => {
                        const selectedType = e.value;
                        formik.setFieldValue("phc_type_id", selectedType.id);
                        formik.setFieldValue("phc_type_name", selectedType.label);
                        setSelectedType(selectedType);
                      }}
                    />
        
                    <Calendar
                       id="fld_from_month_name"
                       name="fld_from_month_name"
                       placeholder="Enter Month & Year"
                       value={date}
                       showButtonBar={!!date}
                       className= "dasboardCalendar"
                       onChange={(e) => {
                        if (!e.value) {
                            // Clear the month/year fields when the calendar is cleared
                            setDate(null);
                            formik.setFieldValue("from_year_id", "");
                            formik.setFieldValue("from_month_id", "");
                            formik.setFieldValue("fld_from_month_name", "");
                        } else {
                            setDate(e.value);
                            const selectedDate = new Date(e.value);
                            const selectedMonthid = (selectedDate.getMonth() + 1).toString().padStart(2, '0');
                            const selectedYear = selectedDate.getFullYear();
                            formik.setFieldValue("from_year_id", selectedYear);
                            formik.setFieldValue("from_month_id", selectedMonthid);
                            formik.setFieldValue("fld_from_month_name", e.value);
                        }
                    }}
                       dateFormat="mm/yy"
                       view="month"
                       showIcon
                       onBlur={formik.handleBlur}
                       maxDate={new Date()}
                   />
                    <Calendar
                      id="fld_to_month_name"
                      name="fld_to_month_name"
                      placeholder="Enter Month & Year"
                      value={date1}
                      showButtonBar={!!date1} 
                      className= "dasboardCalendar"
                      onChange={(e) => {
                        if (!e.value) {
                            setDate1(null);
                            formik.setFieldValue("to_year_id", "");
                            formik.setFieldValue("to_month_id", "");
                            formik.setFieldValue("fld_to_month_name", "");
                        } else {
                            setDate1(e.value);
                            const selectedDate = new Date(e.value);
                            const selectedMonthid = (selectedDate.getMonth() + 1).toString().padStart(2, '0');
                            const selectedYear = selectedDate.getFullYear();
                            formik.setFieldValue("to_year_id", selectedYear);
                            formik.setFieldValue("to_month_id", selectedMonthid);
                            formik.setFieldValue("fld_to_month_name", e.value);
                        }
                    }}
                      dateFormat="mm/yy"
                      view="month"
                      showIcon
                      onBlur={formik.handleBlur}
                      maxDate={new Date()}
                  />
        
                    <div>
                   <Button className="filterFormbutton" type="submit" label='View'/>
                   <Button className="filterClearButton" type="button"  label="Clear"
                    severity="danger" outlined  />
                    </div>
        
                </div> */}

        <div className='grid m-0 gap-2'>
          <div className='col layout'>
            <h2 className="m-0">{noParticpantsEnrolledData}</h2>
            <p className="pr-4 dashboardText">No of Particpants Enrolled</p>
          </div>
          <div className='col layout'>
            <h2 className="m-0">{noHealthWorkerEnrolledData}</h2>
            <p className="pr-4 dashboardText">No of Health Worker Enrolled</p>
          </div>
          <div className='col layout'>
            <h2 className="m-0">{noParticipantScreenedData}</h2>
            <p className="pr-4 dashboardText">No of participants screened per HCW</p>
          </div>
        </div>

        <div className='mt-5 layout'>
          <h4 className='mb-4 mt-0'>Participants Screened per HCW</h4>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={noparticipantsscreenedHCWData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="hcwId" style={{ fontSize: "12px" }} />
              <YAxis style={{ fontSize: "12px" }} />
              <Tooltip />
              <Legend wrapperStyle={{ fontSize: "12px" }}/>
              <Bar dataKey="participants" fill="#82ca9d" barSize={30} />
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div className='mt-5 layout'>
          <h4 className='mb-4 mt-0'>No of participants screened positive by health worker</h4>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={noparticipantsPositiveHealthWorkerData}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="phcName" style={{ fontSize: "12px" }} />
              <YAxis style={{ fontSize: "12px" }} />
              <Tooltip />
              <Legend wrapperStyle={{ fontSize: "12px" }}/>
              <Line type="monotone" dataKey="positiveCount" stroke="#ff7300" strokeWidth={2} />
            </LineChart>
          </ResponsiveContainer>
        </div>

        <div className='mt-5 layout'>
          <h4 className='mb-4 mt-0'>No of Participants identified with mild depression by HCW</h4>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={noParticipantsmildDepressionHCWData}
                dataKey="value"
                nameKey="name"
                outerRadius={100}
                label={renderCustomizedLabel}
                labelLine={false}
              >
                {noParticipantsmildDepressionHCWData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend wrapperStyle={{ fontSize: "12px" }}/>
            </PieChart>
          </ResponsiveContainer>
        </div>

        <div className='grid m-0 mt-5 gap-2'>
          <div className='col layout'>
            <h2 className="m-0">{noParticipantNeedingReferralData}</h2>
            <p className="pr-4 dashboardText">No of Participant needing Referral</p>
          </div>
          <div className='col layout'>
            <h2 className="m-0">{pendingBaselineCounsellingF0Data}</h2>
            <p className="pr-4 dashboardText">PendingBaselineCounselling (F0)</p>
          </div>
          <div className='col layout'>
            <h2 className="m-0">{pendingFollowupsData}</h2>
            <p className="pr-4 dashboardText">Pending Follow-ups</p>
          </div>
          <div className='col layout'>
            <h2 className="m-0">{completedFollowUpsF0F1F2F3F4Data}</h2>
            <p className="pr-4 dashboardText">Completed Follow-ups (F0, F1, F2, F3, F4)</p>
          </div>
        </div>

        <div className='mt-5 layout'>
          <h4 className='mb-4 mt-0'>No. of Participants Dropouts / Withdrawal</h4>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={noofParticpantsDropoutData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="phcName" style={{ fontSize: "12px" }} />
              <YAxis style={{ fontSize: "12px" }} />
              <Tooltip />
              <Legend wrapperStyle={{ fontSize: "12px" }}/>
              <Bar dataKey="total_withdrawals" stackId="a" fill="#8884d8" />
              <Bar dataKey="dropout_phq2" stackId="a" fill="#82ca9d" />
              <Bar dataKey="dropout_phq9" stackId="a" fill="#ffc658" />
              <Bar dataKey="lost_f0" stackId="a" fill="#ff7f50" />
              <Bar dataKey="lost_f1" stackId="a" fill="#a569bd" />
              <Bar dataKey="lost_f2" stackId="a" fill="#f39c12" />
              <Bar dataKey="lost_f3" stackId="a" fill="#16a085" />
              <Bar dataKey="lost_f4" stackId="a" fill="#c0392b" />
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div className='grid m-0 mt-5 gap-2'>
          <div className='col layout'>
            <h2 className="m-0">{noHWsDropoutsWithdrawalData}</h2>
            <p className="pr-4 dashboardText">No. of HWs Dropouts / Withdrawal</p>
          </div>
          <div className='col layout'>
            <h2 className="m-0">{noParticipantReferralRequestData}</h2>
            <p className="pr-4 dashboardText">No. of participant's compliance to referral request</p>
          </div>
        </div>

    </div>
  )
}

export default PRSData